import { Pipe, PipeTransform } from '@angular/core';

import { ThumbnailLayerComponent } from '../components/thumbnail-layer/thumbnail-layer.component';

@Pipe({
    name: 'thumbnailfilter',
    pure: false
})
export class ThumbnailFilterPipe implements PipeTransform {
  transform(items: Object[], filter: String): Object[] {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be kept, false will be filtered out
    return items.filter((item: Object) => this.applyFilter(item, filter));
  }

  /**
   * Perform the filtering.
   *
   * @param {Object} layer capa
   * @param {String} keyFilter The filter to apply.
   * @return {boolean} True if layer satisfies filters, false if not.
   */
  applyFilter(layer: Object, keyFilter: String): boolean {
    if(layer["KEY"] === keyFilter){
      return false;
    }
    else{
      return true;
    }
  }
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/filters/thumbnail-filter.pipe.ts